var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",on:{"mousedown":_vm.mouseDown,"mousemove":_vm.mouseMove,"mouseup":_vm.mouseUp,"touchstart":_vm.touchStart,"touchmove":_vm.touchMove,"touchend":_vm.touchEnd}})
}
var staticRenderFns = []

export { render, staticRenderFns }